var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,2.3c-0.2-0.2-0.4-0.4-0.7-0.6c-0.2-0.2-0.5-0.1-0.7,0.1c-0.2,0.2-0.1,0.5,0.1,0.7 C12.6,2.7,12.8,2.8,13,3C14.3,4.4,15,6.1,15,8s-0.7,3.6-2.1,5c-1.1,1.1-2.6,1.8-4.1,2c-0.3,0-0.5,0.3-0.4,0.5 c0,0.2,0.2,0.4,0.5,0.4c0,0,0,0,0.1,0c1.8-0.2,3.4-1,4.7-2.3C15.2,12.1,16,10.1,16,8S15.2,3.9,13.7,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.8,11.4c-0.3-0.6-0.5-1.2-0.7-1.8C1,9,1,8.5,1,8C1,6.1,1.7,4.4,3,3c1.1-1.1,2.6-1.8,4.1-2 c0.3,0,0.5-0.3,0.4-0.5C7.5,0.2,7.3,0,7,0.1c-1.8,0.2-3.4,1-4.7,2.3C0.8,3.9,0,5.9,0,8c0,0.6,0.1,1.2,0.2,1.7 c0.2,0.7,0.4,1.4,0.8,2.1c0.5,0.9,1.2,1.7,2,2.4c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.1-0.5-0.1-0.7 C2.9,12.9,2.3,12.2,1.8,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,7.3C12,7.3,12,7.2,12,7.3c0-0.1,0.1-0.2,0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0-0.1-0.1-0.1c0,0,0,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0H9.4l1.4-6 c0.1-0.2-0.1-0.5-0.3-0.6c-0.2-0.1-0.5,0-0.6,0.2L4,8.7C3.9,8.8,3.9,9,4,9.2c0.1,0.2,0.2,0.3,0.4,0.3h2.2l-1.4,6 c-0.1,0.2,0.1,0.5,0.3,0.6c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.4-0.2L12,7.3C12,7.3,12,7.3,12,7.3z M7.7,9.1C7.7,9,7.7,9,7.7,9.1 c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1,0 c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0H5.4l4-5.6l-1,4.1c0,0.1,0,0.3,0.1,0.4s0.2,0.2,0.4,0.2h1.8l-4,5.6L7.7,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskActivity);
export default __webpack_public_path__ + "static/media/task-activity.b275ca0b1862340cb1a31b95f66bbc8b.svg";
export { ForwardRef as ReactComponent };